import { getAllUserAddress, postUserAddress, deleteUserAdress, updateUserAddress } from "@/services/user-address-service";

// initial state
const state = () => ({
  addressModel: {
    countryId: null,
    stateId: null,
    cityId: null,
  },
});

// mutations
const mutations = {
  setUserAdressModel(state, data) {
    state.addressModel = data;
  },
};

// actions
const actions = {
  async loadAllUserAddress() {
    return await getAllUserAddress().then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  //Kullanıcı Adres Ekleme
  async postUserAddress(vuexContext, data) {
    return await postUserAddress(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateUserAddress(vuexContext, data) {
    return await updateUserAddress(data).then((response) => {
      let data = response;
      return data;
    });
  },
  async deleteUserAdress(vuexContext, data) {
    return await deleteUserAdress(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addUserAdressModel(vuexContext, data) {
    vuexContext.commit("setUserAdressModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
